export default {
    baseStyle: {
        mainDescriptionContainer: {
            flexDir: 'column',
            marginTop: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            marginBottom: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
        },
        innerDescriptionContainer: {
            flexDir: 'column',
            textStyle: 'body-large',
            layerStyle: 'full-width',
            listStylePosition: 'inside',
            fontWeight: 'normal',
            margin: {base: '0 auto', md: 'unset'},
            color: 'foreground.neutral.default',
        },
        readMoreButton: {
            variant: 'link-button',
            marginTop: ['small.base'],
            paddingLeft: 0,
        },
        gradientBackground: {
            WebkitMaskImage: 'linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))',
        },
    },
}
